import { render, staticRenderFns } from "./LowLiquidityArbitrage.vue?vue&type=template&id=64554671"
import script from "./LowLiquidityArbitrage.vue?vue&type=script&lang=js"
export * from "./LowLiquidityArbitrage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports